export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export const promptStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

export const adjustSummaryStyles = ({ palette }) => ({
  color: palette.text.secondary,
});
